<div class="app flex-row align-items-center">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-6">
				<div class="clearfix">
					<h1 class="float-left display-3 mr-4"></h1>
					<h4 class="pt-3" [ro-i18n] eikey="errors.fiveHundred">Houston, we have a problem!</h4>
					<p class="text-muted" [ro-i18n] eikey="errors.fiveHundredMsg">The page you are looking for is temporarily unavailable.</p>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-6">
				<a [routerLink]="['/dashboard']" [ro-i18n] eikey="errors.backHome">New Email</a>
			</div>
		</div>
	</div>
</div>
